'use client';

import TabHead from './TabHead';
import TabContentA from './TabContentA';
import TabContentB from './TabContentB';
import { tranText } from './tranText';
import getLocal from '@/app/utils/getLocal';

export default function Content({ data = {}, creditsData, activeType, callback, winCallback, itemCallback }: any) {
    const { locale } = getLocal();
    const textObj = tranText[locale] || tranText['us'];
    const headList = [
        {
            label: textObj.tab1,
            value: 'Discount',
        },
        {
            label: textObj.tab2,
            value: 'Product',
        },
    ];
    // tab点击切换
    const tabCallback = (item: any) => {
        callback && callback(item);
    };

    return (
        <>
            {textObj.title && <h3 className="eco-redeem-rewards-title">{textObj.title}</h3>}
            <div className="eco-redeem-rewards-box">
                <TabHead data={headList} creditsData={creditsData} activeType={activeType} callback={tabCallback} />
                <div className={`eco-tab-content eco-tab-content-Discount${activeType === 'Discount' ? ' eco-tab-active' : ''}`}>
                    <TabContentA data={data} creditsData={creditsData} winCallback={winCallback} itemCallback={itemCallback} />
                </div>
                <div className={`eco-tab-content eco-tab-content-Product${activeType === 'Product' ? ' eco-tab-active' : ''}`}>
                    <TabContentB data={data} creditsData={creditsData} winCallback={winCallback} itemCallback={itemCallback} />
                </div>
            </div>
        </>
    );
}
